module.exports = __webpack_public_path__ + "static/media/axe_mastery.8dde0d23.png";